import store from '@/store'

/**
 * GTMログ送信(User-ID付き)
 * @param {string} eventName イベント名
 */
export const gtmLogWithUID = (eventName, extraParams) => {

  window.dataLayer = window.dataLayer || []

  if (eventName) {
    // ユーザーを識別するIDが取得できる(ログインしている)場合

    // 利用者ID
    const userId = store.state.profile.id ?? ''
    // 契約識別コード
    const identificationCode = store.state.profile.identification_code ?? ''

    // GAに送信するユーザーID（契約識別コード＋利用者ID）
    const userId4GA = identificationCode + '-' + userId

    const basicParams = {
      'event': eventName,
      'uid': userId4GA
    }

    const params = { ...basicParams, ...extraParams }

    // タグマネに送信するため、gtag.jsのgtag()関数ではなく、
    // gtm.jsのdataLayer.push()関数でログを送信する
    window.dataLayer.push(params)
  }
}

/**
 * GTMログ送信
 * @param {string} eventName イベント名
 */
export const gtmLog = (eventName, extraParams) => {
  window.dataLayer = window.dataLayer || []

  if (eventName) {

    const basicParams = {
      'event': eventName
    }

    const params = { ...basicParams, ...extraParams }

    window.dataLayer.push(params)
  }
}
